import styled from 'styled-components'

import { Z_INDEX_MODAL } from 'src/constants/z-indexes'
import { fontWeight, color } from 'src/styles'
import { fontSize } from 'src/styles/fonts'

interface OverlayProps {
  isOpen: boolean
}

export const OuterWrap = styled.div<{ isOpen: boolean }>`
  position: fixed;
  top: 0;
  z-index: ${Z_INDEX_MODAL};
  width: 100vw;
  height: 100%;
  display: ${({ isOpen }) => (isOpen ? 'flex' : 'none')};
  justify-content: center;
  align-items: center;
`

export const Overlay = styled.button<OverlayProps>`
  position: fixed;
  top: 0;
  width: 100vw;
  height: 100%;
  display: ${({ isOpen }) => (isOpen ? 'flex' : 'none')};
  background-color: rgba(0, 0, 0, 0.5);
`

export const InnerWrap = styled.div`
  background: white;
  border-radius: 1.6rem;
  text-align: center;
  position: relative;
  overflow: auto;
  max-height: 100%;
`

export const CloseButton = styled.button`
  position: absolute;
  top: 1.6rem;
  right: 1.6rem;
  padding: 0;
`

export const Wrap = styled.div`
  margin: 9.6rem 6.4rem 3rem;
`

export const Title = styled.h3`
  font-size: ${fontSize.LARGE_XL};
  font-weight: ${fontWeight.EXTRA};
  margin-top: 0;
`

export const Paragraph = styled.p`
  color: ${color.WARM_GREY};
  line-height: 1.5;
`

export const ColumnWrap = styled.div`
  display: flex;
  flex-direction: column;
`

interface ButtonProps {
  secondary?: boolean
  red?: boolean
}
export const Button = styled.button<ButtonProps>`
  border-radius: 2.8rem;
  background-color: ${({ secondary, red }) => {
    if (secondary) return 'transparent'
    if (red) return color.ORANGEY_RED
    return color.DUSTY_ORANGE
  }};
  font-size: ${fontSize.NORMAL};
  font-weight: ${fontWeight.BOLD};
  color: ${({ secondary }) => (secondary ? color.WARM_GREY : '#fff')};
  padding: 1.6rem 6rem;

  :disabled {
    background-color: rgba(87, 61, 57, 0.1);
  }
`
